(() => {
  'use strict';
  const config = JSON.parse(document.getElementById('ThemeConfig')?.textContent || '{}');
  const root = config.root || '/';
  const status = message => { const node = document.getElementById('LiveStatus'); if (node) node.textContent = message; };
  const error = (scope, message) => {
    const target = scope.querySelector('.form-error');
    if (target) { target.hidden = false; target.textContent = message; }
    status(message);
  };
  async function jsonRequest(url, options = {}) {
    const response = await fetch(url, { credentials: 'same-origin', ...options });
    let data;
    try { data = await response.json(); } catch { throw new Error(config.error); }
    if (!response.ok) throw new Error(typeof data.description === 'string' ? data.description : config.error);
    return data;
  }
  const openDialog = (dialog, trigger) => {
    if (!dialog || dialog.open) return;
    document.querySelectorAll('dialog[open]').forEach(d => d.close());
    dialog._trigger = trigger || document.activeElement;
    dialog.showModal();
    document.documentElement.classList.add('dialog-open');
    dialog.querySelector('[data-close]')?.focus();
  };
  document.addEventListener('close', event => {
    if (event.target.tagName !== 'DIALOG') return;
    document.documentElement.classList.remove('dialog-open');
    event.target._trigger?.focus();
  }, true);
  document.addEventListener('click', event => {
    const opener = event.target.closest('[data-open]');
    if (opener) { const dialog = document.getElementById(opener.dataset.open); if (dialog) { event.preventDefault(); openDialog(dialog, opener); if (dialog.id === 'CartDrawer') refreshCart().catch(() => error(dialog, config.error)); } }
    const closer = event.target.closest('[data-close]');
    if (closer) closer.closest('dialog')?.close();
    if (event.target.tagName === 'DIALOG') {
      const rect = event.target.getBoundingClientRect();
      if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) event.target.close();
    }
    const qty = event.target.closest('[data-qty-step]');
    if (qty) {
      const input = qty.parentElement.querySelector('input');
      const step = Number(input.step) || 1, min = Number(input.min) || 1, max = input.max ? Number(input.max) : Infinity;
      input.value = Math.max(min, Math.min(max, Number(input.value) + Number(qty.dataset.qtyStep) * step));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const tab = event.target.closest('[data-shelf-tab]');
    if (tab) {
      const shelf = tab.closest('[data-shelf]');
      shelf.querySelectorAll('[data-shelf-tab]').forEach(t => { t.classList.toggle('on', t === tab); t.setAttribute('aria-pressed', String(t === tab)); });
      shelf.querySelectorAll('[data-shelf-panel]').forEach(panel => panel.hidden = panel.id !== tab.dataset.shelfTab);
    }
  });
  function sectionIds() { return ['cart-drawer', ...Array.from(document.querySelectorAll('[data-main-cart]'), e => e.dataset.sectionId)]; }
  function renderCartSections(sections) {
    const parser = new DOMParser();
    if (sections?.['cart-drawer']) {
      const source = parser.parseFromString(sections['cart-drawer'], 'text/html');
      const target = document.querySelector('#CartDrawer [data-cart-render]');
      const replacement = source.querySelector('[data-cart-render]');
      if (target && replacement) target.replaceWith(replacement);
    }
    document.querySelectorAll('[data-main-cart]').forEach(target => {
      const html = sections?.[target.dataset.sectionId];
      if (!html) return;
      const replacement = parser.parseFromString(html, 'text/html').querySelector('[data-main-cart]');
      if (replacement) target.replaceWith(replacement);
    });
  }
  let refreshSequence = 0;
  async function refreshCart() {
    const seq = ++refreshSequence;
    const [cart, sections] = await Promise.all([
      jsonRequest(root + 'cart.js'),
      jsonRequest(root + '?sections=' + encodeURIComponent(sectionIds().join(',')))
    ]);
    if (seq !== refreshSequence) return;
    renderCartSections(sections);
    document.querySelectorAll('[data-cart-count]').forEach(node => node.textContent = cart.item_count);
    return cart;
  }
  let cartBusy = false;
  document.addEventListener('submit', async event => {
    const form = event.target.closest('[data-product-form]');
    if (!form) return;
    event.preventDefault();
    if (cartBusy || form.dataset.busy === 'true') return;
    cartBusy = true; form.dataset.busy = 'true'; form.setAttribute('aria-busy', 'true');
    const buttons = Array.from(form.querySelectorAll('button[type="submit"]'));
    buttons.forEach(b => b.disabled = true);
    const errorNode = form.querySelector('.form-error'); if (errorNode) errorNode.hidden = true;
    status(config.loading);
    const checkout = event.submitter?.name === 'return_to';
    try {
      const data = new FormData(form);
      data.delete('return_to');
      await jsonRequest(root + 'cart/add.js', { method: 'POST', body: data });
      if (checkout) { window.location.assign(root + 'checkout'); return; }
      try { await refreshCart(); } catch { window.location.assign(config.cart || root + 'cart'); return; }
      openDialog(document.getElementById('CartDrawer'), event.submitter);
      status(config.added);
    } catch (e) { error(form, e.message || config.error); }
    finally { cartBusy = false; form.dataset.busy = 'false'; form.removeAttribute('aria-busy'); buttons.forEach(b => b.disabled = false); }
  });
  async function changeCart(control, quantity) {
    if (cartBusy || !Number.isInteger(quantity) || quantity < 0) return;
    cartBusy = true;
    const scope = control.closest('form');
    const key = control.dataset.key;
    const owningDialog = control.closest('dialog');
    const actionQuantity = control.dataset.quantity;
    const activeId = document.activeElement.id;
    scope?.setAttribute('aria-busy', 'true');
    document.querySelectorAll('[data-cart-change], [data-cart-quantity]').forEach(e => { e.setAttribute('aria-disabled', 'true'); if ('disabled' in e) e.disabled = true; });
    try {
      const cart = await jsonRequest(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: key, quantity, sections: sectionIds(), sections_url: window.location.pathname }) });
      ++refreshSequence;
      renderCartSections(cart.sections);
      document.querySelectorAll('[data-cart-count]').forEach(e => e.textContent = cart.item_count);
      if (!cart.sections?.['cart-drawer']) await refreshCart();
      if (activeId) document.getElementById(activeId)?.focus();
      else { const matching = Array.from(document.querySelectorAll('[data-cart-change]')).find(e => e.dataset.key === key && e.dataset.quantity === actionQuantity); if (matching) matching.focus(); else if (owningDialog) owningDialog.querySelector('[data-close]')?.focus(); else document.querySelector('[data-main-cart] a, [data-main-cart] button')?.focus(); }
      status(config.added);
    } catch (e) { if (scope?.isConnected) error(scope, e.message || config.error); }
    finally {
      cartBusy = false; scope?.removeAttribute('aria-busy');
      document.querySelectorAll('[data-cart-change], [data-cart-quantity]').forEach(e => { e.removeAttribute('aria-disabled'); if ('disabled' in e) e.disabled = false; });
    }
  }
  document.addEventListener('click', event => {
    const change = event.target.closest('[data-cart-change]');
    if (change) { event.preventDefault(); changeCart(change, Number(change.dataset.quantity)); }
  });
  document.addEventListener('change', event => {
    if (event.target.matches('[data-cart-quantity]')) changeCart(event.target, Number(event.target.value));
    // Standard product-form quantities must respect both Shopify rules and stock.
    if (event.target.matches('input[name="quantity"]') && event.target.closest('form[data-product-form]')) {
      const input = event.target, min = Number(input.min) || 1, step = Number(input.step) || 1;
      const max = input.max === '' ? Infinity : Number(input.max);
      const value = Number(input.value) || min;
      input.value = Math.max(min, min + Math.floor((Math.min(max, Math.max(min, value)) - min) / step) * step);
    }
    if (event.target.matches('[data-localization], [data-sort]')) event.target.form.requestSubmit();
  });
  window.addEventListener('pageshow', event => { if (event.persisted) refreshCart().catch(() => {}); });
  document.addEventListener('visibilitychange', () => { if (!document.hidden && !cartBusy) refreshCart().catch(() => {}); });
  class HeroSlideshow extends HTMLElement {
    connectedCallback() {
      this.slides = Array.from(this.querySelectorAll('[data-slide]')); this.index = 0; this.paused = false;
      this.abort = new AbortController(); const opts = { signal: this.abort.signal };
      this.addEventListener('click', e => {
        if (e.target.closest('[data-slide-next]')) this.go(this.index + 1);
        if (e.target.closest('[data-slide-prev]')) this.go(this.index - 1);
        const dot = e.target.closest('[data-slide-to]'); if (dot) this.go(Number(dot.dataset.slideTo));
        const pause = e.target.closest('[data-slide-pause]'); if (pause) { this.paused = !this.paused; pause.setAttribute('aria-pressed', String(this.paused)); }
      }, opts);
      const direction = () => getComputedStyle(this).direction === 'rtl' ? -1 : 1;
      this.addEventListener('keydown', e => {
        if (e.target.closest('input, select, textarea')) return;
        if (!['ArrowRight', 'ArrowLeft'].includes(e.key)) return;
        e.preventDefault(); this.go(this.index + (e.key === 'ArrowRight' ? 1 : -1) * direction());
      }, opts);
      // Passive touch listeners retain vertical page scrolling and ignore taps on controls.
      this.addEventListener('touchstart', e => {
        this.touch = e.touches.length === 1 && !e.target.closest('a, button, input, select, textarea')
          ? { x: e.touches[0].clientX, y: e.touches[0].clientY } : null;
      }, { ...opts, passive: true });
      this.addEventListener('touchend', e => {
        if (!this.touch || !e.changedTouches.length) return;
        const dx = e.changedTouches[0].clientX - this.touch.x, dy = e.changedTouches[0].clientY - this.touch.y;
        this.touch = null;
        if (Math.abs(dx) >= 45 && Math.abs(dx) > Math.abs(dy) * 1.5) this.go(this.index + (dx < 0 ? 1 : -1) * direction());
      }, { ...opts, passive: true });
      this.addEventListener('touchcancel', () => { this.touch = null; }, opts);
      this.interval = setInterval(() => {
        if (this.dataset.autoplay === 'true' && !this.paused && !document.hidden && !this.matches(':hover') && !this.contains(document.activeElement) && !matchMedia('(prefers-reduced-motion: reduce)').matches) this.go(this.index + 1);
      }, Number(this.dataset.interval) || 6000);
      document.addEventListener('shopify:block:select', e => { const i = this.slides.findIndex(s => s.dataset.blockId === e.detail.blockId); if (i >= 0) { this.paused = true; this.go(i); } }, opts);
    }
    go(index) {
      if (!this.slides.length) return;
      this.index = (index + this.slides.length) % this.slides.length;
      this.slides.forEach((slide, i) => slide.hidden = i !== this.index);
      this.querySelectorAll('[data-slide-to]').forEach((dot, i) => dot.setAttribute('aria-pressed', String(i === this.index)));
    }
    disconnectedCallback() { clearInterval(this.interval); this.abort?.abort(); }
  }
  customElements.define('hero-slideshow', HeroSlideshow);
  class PredictiveSearch extends HTMLElement {
    connectedCallback() {
      this.input = this.querySelector('input[type="search"]'); this.results = this.querySelector('.predictive-results');
      this.sequence = 0; this.events = new AbortController(); const opts = { signal: this.events.signal };
      this.input.addEventListener('input', () => { clearTimeout(this.timer); this.sequence++; this.request?.abort(); if (this.input.value.trim().length < 2) return this.close(); this.timer = setTimeout(() => this.search(), 200); }, opts);
      this.addEventListener('keydown', e => {
        if (e.key === 'Escape') { this.close(); this.input.focus(); }
        if (!['ArrowDown','ArrowUp'].includes(e.key) || this.results.hidden) return;
        const links = Array.from(this.results.querySelectorAll('a'));
        if (!links.length) return; e.preventDefault();
        const index = links.indexOf(document.activeElement); links[(index + (e.key === 'ArrowDown' ? 1 : -1) + links.length) % links.length].focus();
      }, opts);
      this.addEventListener('focusout', () => setTimeout(() => { if (!this.contains(document.activeElement)) this.close(); }, 0), opts);
    }
    close() { this.results.hidden = true; this.input.setAttribute('aria-expanded', 'false'); }
    async search() {
      const seq = ++this.sequence; this.request = new AbortController();
      try {
        const params = new URLSearchParams({ q: this.input.value.trim(), 'resources[type]': 'product', 'resources[limit]': '6', section_id: 'predictive-search' });
        const response = await fetch((config.search || root + 'search/suggest') + '?' + params, { signal: this.request.signal });
        if (!response.ok) return this.close();
        const html = await response.text(); if (seq !== this.sequence) return;
        const doc = new DOMParser().parseFromString(html, 'text/html');
        this.results.innerHTML = doc.querySelector('#shopify-section-predictive-search')?.innerHTML || '';
        this.results.hidden = false; this.input.setAttribute('aria-expanded', 'true');
      } catch (e) { if (e.name !== 'AbortError') this.close(); }
    }
    disconnectedCallback() { clearTimeout(this.timer); this.request?.abort(); this.events?.abort(); }
  }
  customElements.define('predictive-search', PredictiveSearch);
  class ProductDetail extends HTMLElement {
    connectedCallback() {
      this.events = new AbortController(); const opts = { signal: this.events.signal };
      this.addEventListener('click', e => { const thumb = e.target.closest('[data-media-target]'); if (thumb) this.showMedia(thumb.dataset.mediaTarget); }, opts);
      this.addEventListener('click', e => { const link = e.target.closest('[data-option-link]'); if (link && !e.ctrlKey && !e.metaKey && !e.shiftKey) { e.preventDefault(); this.selectVariant(link); } }, opts);
      this.initTabs();
      const selected = JSON.parse(this.querySelector('[data-current-variant]')?.textContent || 'null');
      if (selected?.featured_media) this.showMedia('Media-' + this.dataset.sectionId + '-' + selected.featured_media.id);
    }
    initTabs() {
      const info = this.querySelector('[data-information]'); if (!info) return;
      const list = info.querySelector('[role="tablist"]'); const panels = Array.from(info.querySelectorAll(':scope > details'));
      info.classList.add('enhanced'); list.hidden = false;
      const activate = index => { panels.forEach((panel, i) => { panel.hidden = i !== index; panel.open = i === index; }); Array.from(list.children).forEach((tab, i) => { tab.setAttribute('aria-selected', String(i === index)); tab.tabIndex = i === index ? 0 : -1; }); };
      panels.forEach((panel, index) => {
        const button = document.createElement('button'); button.type = 'button'; button.className = 'ptab'; button.textContent = panel.querySelector('summary').textContent; button.setAttribute('role', 'tab'); button.id = 'Tab-' + this.dataset.sectionId + '-' + index;
        panel.id = 'Panel-' + this.dataset.sectionId + '-' + index; panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', button.id); button.setAttribute('aria-controls', panel.id);
        button.addEventListener('click', () => activate(index));
        button.addEventListener('keydown', e => { let next = index; if (e.key === 'ArrowRight') next++; else if (e.key === 'ArrowLeft') next--; else if (e.key === 'Home') next = 0; else if (e.key === 'End') next = panels.length - 1; else return; e.preventDefault(); next = (next + panels.length) % panels.length; activate(next); list.children[next].focus(); });
        list.append(button);
      }); activate(0);
    }
    showMedia(id) {
      if (!this.querySelector(`[id="${id}"]`)) return;
      this.querySelectorAll('[data-media]').forEach(el => { el.hidden = el.id !== id; if (el.hidden) el.querySelectorAll('video').forEach(v => v.pause()); });
      this.querySelectorAll('[data-media-target]').forEach(el => el.setAttribute('aria-pressed', String(el.dataset.mediaTarget === id)));
    }
    async selectVariant(link) {
      this.request?.abort(); this.request = new AbortController();
      const selectedId = link.dataset.optionId; const quantity = this.querySelector('[name="quantity"]').value;
      this.querySelectorAll('button[type="submit"]').forEach(b => b.disabled = true);
      this.setAttribute('aria-busy', 'true');
      try {
        const url = new URL(link.href, window.location.origin); url.searchParams.set('section_id', this.dataset.sectionId);
        const response = await fetch(url, { signal: this.request.signal }); if (!response.ok) throw new Error(config.error);
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html'); const next = doc.querySelector('product-detail'); if (!next) throw new Error(config.error);
        const newQuantity = next.querySelector('[name="quantity"]'); if (newQuantity) { const min = Number(newQuantity.min) || 1, step = Number(newQuantity.step) || 1, max = Number(newQuantity.max) || Infinity; newQuantity.value = Math.min(max, Math.max(min, min + Math.floor((Number(quantity) - min) / step) * step)); }
        const publicUrl = new URL(link.href, window.location.origin); history.replaceState({}, '', publicUrl);
        this.replaceWith(next); next.querySelector('[data-option-id="' + selectedId + '"]')?.focus();
      } catch (e) { if (e.name !== 'AbortError') { error(this, config.error); window.location.assign(link.href); } }
    }
    disconnectedCallback() { this.events?.abort(); this.request?.abort(); }
  }
  customElements.define('product-detail', ProductDetail);
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      this.request = new AbortController();
      this.observer = new IntersectionObserver(entries => { if (entries[0].isIntersecting) { this.observer.disconnect(); this.load(); } }, { rootMargin: '300px' }); this.observer.observe(this);
    }
    async load() { try { const response = await fetch(this.dataset.url, { signal: this.request.signal }); if (!response.ok) return; const doc = new DOMParser().parseFromString(await response.text(), 'text/html'); const content = doc.querySelector('product-recommendations'); if (content) this.innerHTML = content.innerHTML; } catch {} }
    disconnectedCallback() { this.observer?.disconnect(); this.request?.abort(); }
  }
  customElements.define('product-recommendations', ProductRecommendations);
})();
